document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => {

    /*==================================
    ELEMENTS
    ==================================*/

    const header = document.getElementById('wgHeader');

    const mobile = document.querySelector('[data-mobile]');

    const openButton = document.querySelector('[data-mobile-open]');

    const closeButtons = document.querySelectorAll('[data-mobile-close]');

    const search = document.querySelector('[data-search]');

    const searchOpen = document.querySelector('[data-search-open]');

    const searchClose = document.querySelectorAll('[data-search-close]');

    const details = document.querySelectorAll('.wg-mobile__group');



    /*==================================
    HEADER SCROLL
    ==================================*/

    function headerScroll(){

        if(!header) return;

        header.classList.toggle('is-scrolled', window.scrollY > 40);

    }

    headerScroll();

    window.addEventListener('scroll', headerScroll);



    /*==================================
    MOBILE DRAWER
    ==================================*/

    function openDrawer(){

        if(!mobile) return;

        mobile.classList.add('is-active');

        document.body.style.overflow='hidden';

    }

    function closeDrawer(){

        if(!mobile) return;

        mobile.classList.remove('is-active');

        document.body.style.overflow='';

        details.forEach(item=>item.removeAttribute('open'));

    }

    openButton?.addEventListener('click', openDrawer);

    closeButtons.forEach(button=>{

        button.addEventListener('click', closeDrawer);

    });



    /*==================================
    SEARCH
    ==================================*/

    function openSearch(){

        if(!search) return;

        search.classList.add('is-active');

        document.body.style.overflow='hidden';

    }

    function closeSearch(){

        if(!search) return;

        search.classList.remove('is-active');

        document.body.style.overflow='';

    }

    searchOpen?.addEventListener('click', openSearch);

    searchClose.forEach(button=>{

        button.addEventListener('click', closeSearch);

    });



   /*==================================
DETAILS ACCORDION
==================================*/

details.forEach(item=>{

    item.addEventListener('toggle',()=>{

        if(item.open){

            details.forEach(other=>{

                if(other!==item){

                    other.open=false;

                }

            });

        }

    });

});



    /*==================================
    ESC KEY
    ==================================*/

    document.addEventListener('keydown',e=>{

        if(e.key!=='Escape') return;

        closeDrawer();

        closeSearch();

    });

});

async function updateCartCount() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const badge = document.querySelector('.wg-cart__count');

        if (!badge) return;

        if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = 'flex';
        } else {
            badge.style.display = 'none';
        }
    } catch (e) {}
}

document.addEventListener('click', () => {
    setTimeout(updateCartCount, 500);
});

window.addEventListener('pageshow', updateCartCount);